<template>
  <b-card v-if="data" no-body class="card-statistics">
    <b-card-header>
      <b-card-title>{{ statisticTitle }}</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col v-for="item in data" :key="item.icon" :class="item.customClass" xl="3" sm="6">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar :variant="item.color" size="48">
                <feather-icon :icon="item.icon" size="24" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ kFormatter(item.title) }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ $t(item.subtitle) }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
} from 'bootstrap-vue'
import { kFormatter } from '@core/utils/filter'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    ladata: {
      type: Array,
      default: () => [],
    },
    gadata: {
      type: Array,
      default: () => [],
    },
    statisticTitle: {
      type: String,
      default: '',
    }
  },
  computed: {
    data() {
      return this.gadata.concat(this.ladata)
    },
  },
  methods: {
    kFormatter,
  },
}
</script>
